<template>
    <div>
        <v-client-table :columns="columns" :data="data" :options="options" :show-sort-icons="true" ref="table"
                        :class="data">
            <div class="intro" slot="beforeFilter" style="position: relative;">
                <h2>{{ $t(headline) }}</h2>
                <p v-if="description">{{ $t(description) }}</p>
            </div>
            <div slot="afterFilter" class="add-button" v-if="!hasLimitedAccess">

                <contract-filter v-model="orderBy"/>
                <input-search v-model="query"/>

                <router-link v-if="getTenantAccess === null" disabled to="#"
                             class="button green">
                    <SvgIcon icon="plus-circle"/>
                    {{ $t('contracts.addnew.button') }}
                </router-link>
                <router-link to="#" disabled class="button green legacy-button">
                    <SvgIcon icon="plus-circle"/>
                    {{ $t('contracts.addnew.upload-legacy') }}
                </router-link>
            </div>
            <!-- <div slot="address" slot-scope="props">
                <a v-if="props.row.link" :href="props.row.link">{{ props.row.address }}</a>
                <span v-else>{{ props.row.address }}</span>
            </div> -->
            <!-- ADDRESS -->
            <div slot="address" class="data-label" :data-label="$t('properties.table.screenings.address')"
                 slot-scope="props">
                <a v-if="props.row.legacy && props.row.link" target="_blank" :href="props.row.link" class="row-link">
                    <span>{{ props.row.address }} <span class="city-info"> {{ props.row.city }}</span></span>
                </a>

                <a v-else-if="!props.row.legacy && props.row.link" :href="props.row.link" class="row-link">
                    <span>{{ props.row.address }}
                        <span class="city-info">{{ props.row.city }}</span>
                    </span>
                </a>

                <span v-else>{{ props.row.address }} <span class="city-info"> {{ props.row.city }}</span></span>
            </div>
            <div slot="tenant_name" class="data-label" :data-label="$t('properties.table.contracts.tenant')"
                 slot-scope="props">
                {{ props.row.tenant_name }}
            </div>
            <div slot="expires_on" class="data-label" :data-label="$t('properties.table.contracts.occupancydate')"
                 slot-scope="props">
                <span v-if="props.row.expires_on">{{ props.row.expires_on }}</span>
                <span v-else>{{ $t('general.not-defined.label') }}</span>
            </div>
            <div slot="status" class="data-label" :data-label="$t('properties.table.contracts.status')"
                 slot-scope="props">
                <span v-if="props.row.status">{{ props.row.status }}</span>
                <span v-else>{{ $t('general.uploaded.label') }}</span>
            </div>
            <a slot="more" slot-scope="props">
                <table-dropdown v-if="!props.row.legacy">
                    <li v-if="props.row.statusId == 5" v-on:click="releaseContract(props.row.id)">
                        {{ $t('draft-contract.release-contract.button') }}
                    </li>
                    <li v-if="props.row.status == 'properties.table.contracts.inprogress'"
                        v-on:click="open(props.row.id)">{{ $t('user.settings.label.edit') }}
                    </li>
                    <li v-on:click="openContract(props.row.id, 'contract')">
                        {{ $t('draft-contract.download-contract.button') }}
                    </li>
                    <li v-if="!hasLimitedAccess" v-on:click="cloneContract(props.row.id)">
                        {{ $t('draft-contract.clone-contract.button') }}
                    </li>
                    <li v-if="!hasLimitedAccess" v-on:click="deleteContract(props.row.id, false)">
                        {{ $t('draft-contracts.delete') }}
                    </li>
                    <li v-if="props.row.houseRulesPdf" v-on:click="openContract(props.row.id, 'houserules')">
                        {{ $t('draft-contracts.download-house-rules.label') }}
                    </li>
                    <li v-if="props.row.energyRankPdf" v-on:click="openContract(props.row.id, 'energyrank')">
                        {{ $t('draft-contracts.download-energyrank.label') }}
                    </li>
                </table-dropdown>
                <table-dropdown v-else>
                    <li v-on:click="deleteContract(props.row.id, true)">
                        {{ $t('draft-contracts.delete') }}
                    </li>
                </table-dropdown>
            </a>

        </v-client-table>
    </div>
</template>

<script>
import Vue from 'vue';
import Loader from './Loader.vue';
import SvgIcon from './Svg.vue';
import TableDropdown from './TableDropdown';
import {mapGetters} from 'vuex';
import ContractFilter from "./ContractFilter";
import InputSearch from "./InputSearch";
import createEntity from "../mixins/create-entity";

export default {
    mixins: [createEntity],
    props: [
        'headline',
        'data',
        'description',
    ],
    computed: {
        ...mapGetters([
            'hasLimitedAccess',
            'getToken',
            'getTenantAccess'
        ]),
    },
    components: {
        InputSearch,
        ContractFilter,
        TableDropdown,
        SvgIcon,
        Loader,
    },
    data: () => ({
        columns: ['address', 'city', 'tenant_name', 'expires_on', 'status', 'more'],
        orderBy: 'id,desc',
        query: '',
        options: {
            headings: {
                address: 'tgext',
                city: 'City',
                tenant_name: 'Tenant',
                expires_on: 'Occupancy date',
                status: 'Status',
                more: 'More'
            },
            sortable: [],
            filterable: [],
            texts: {
                filterPlaceholder: 'Search',
                filter: '',
                noResults: ''
            },
            columnsClasses: {
                address: 'address',
                city: 'city',
                tenant_name: 'tenant-name',
                expires_on: 'deadline',
                status: 'status',
                more: 'more'
            },
        }
    }),
    methods: {
        releaseContract(id) {
            axios({
                url: window.config.apiUrl + 'api/contracts/digital-contract/' + id + '/release',
                method: 'POST',

            }).then(response => {
                this.$store.commit('setSuccessBarMessage', this.$t('digital-contract.release-to-tenant.label'));
            });
        },
        open(id) {
            this.$router.push('contracts/digital-contract/edit/' + id);
        },
        openContract(id, resource, customUploadFileId) {
            switch (resource) {
                case 'contract':
                    window.open(window.config.apiUrl + 'api/contract/' + id + '?token=' + this.getToken);
                    break;

                case 'houserules':
                    window.open(window.config.apiUrl + 'house-rules/' + id + '?token=' + this.getToken);
                    break;
                case 'energyrank':
                    window.open(window.config.apiUrl + 'energy-rank/' + id + '?token=' + this.getToken);
                    break;
                case 'custom':
                    window.open(window.config.apiUrl + 'contracts/digital-contract/' + id + '/custom-upload/' + customUploadFileId + '?token=' + this.getToken);
                    break;
            }
        },
        deleteContract(id, legacy) {
            if (confirm(this.$t('contracts.delete.confirmation'))) {
                var url = legacy ? '/legacy-contract/' + id : '/draft-contract/' + id;

                Vue.api.delete(url, {}, {
                    callback: () => this.$emit('deleted'),
                });
            }
        },
        cloneContract(id) {
            this.$router.push('/contracts/digital-contract/select-property?clone=' + id);
        },
    },
    created() {
        this.options.headings.address = this.$t('properties.table.contracts.label');
        this.options.headings.city = this.$t('properties.table.contracts.city');
        this.options.headings.tenant_name = this.$t('properties.table.contracts.tenant');
        this.options.headings.expires_on = this.$t('properties.table.contracts.occupancydate');
        this.options.headings.status = this.$t('properties.table.contracts.status');
        this.options.headings.more = this.$t('tables.more.label');
        this.options.texts.filterPlaceholder = this.$t('search.filterplaceholder');
        this.options.texts.noResults = this.$t('table.no-results.label');
    },
    watch: {
        orderBy: function () {
            this.$emit('filter', this.query, this.orderBy)
        },
        query: function () {
            this.$emit('filter', this.query, this.orderBy)
        }
    }
}
</script>
